import React, { useContext } from "react";
import { AuthContext } from "../providers/AuthValidationLayer";
import { Unauthorized } from "./Unauthorized";

const RequirePermission = ({ heading, subHeading, method, children }) => {
  const { user, hasPermission } = useContext(AuthContext);

  const allowed = hasPermission?.(heading, subHeading, method);

  if (!allowed) {
    return <Unauthorized />;
  }
  return children;
};

export default RequirePermission;
